module.exports = __webpack_public_path__ + "static/img/platform-bg-3.e0ed33d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/platform-bg-3.png
// module id = PYDF
// module chunks = 0